import React, { useState, useEffect, useRef } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import SearchIcon from "@mui/icons-material/Search";
import CountUp from "react-countup";
import {
	Card,
	CardBody,
	Row,
	Col,
	CardFooter,
	CardTitle,
	Alert,
	button
} from "reactstrap";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import Autocomplete from "@mui/lab/Autocomplete";
import { makeStyles } from "@mui/styles";
import { getWalletDashboard } from "../../redux/actions/getWallletDashboardAction";
import { FormControl } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import themeDetails from "../../getThemeDetails";

import GetComplainBarDashboard from "./Complaints/ComplainBarChart/index";
import GetComplainLineChartDashboard from "./Complaints/ComplainLineChart/index";
import GetComplainTableChartDashboard from "./Complaints/ComplainTableChart/index";

import BarGraph from "../../../src/assets/img/GraphIcon/bargraph_blue.png";
import LineGraph from "../../../src/assets/img/GraphIcon/linegraph_blue.png";
import TableGraph from "../../../src/assets/img/GraphIcon/tablegraph_blue.png";

import BarGraph_White from "../../../src/assets/img/GraphIcon/bargraph_white.png";
import LineGraph_White from "../../../src/assets/img/GraphIcon/linegraph_white.png";
import TableGraph_White from "../../../src/assets/img/GraphIcon/tablegraph_white.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

import { getRegenerateToken } from "../../redux/actions/regenerateTokenAction";
import { getTransactionCurrencyListAction } from "../../redux/actions/getTransactionCurrencyList";
import {

	getCustomerIdAndNameList
} from "../../redux/actions/getCustomerIdAndNameListAction";


import getSymbolFromCurrency from "currency-symbol-map";
import { Doughnut } from "react-chartjs-2";
const WalletDashboard = () => {
	const [isLoading, setIsLoading] = useState(true);
	const Theme = useSelector((state) => state.theme.theme);

	const tempArr = {
		complainMonthlyCount: [
			{
				fromDate: "2022-07-09",
				toDate: "2022-07-02",
				pendingCount: 3
			},
			{
				fromDate: "2022-07-02",
				toDate: "2022-06-25",
				pendingCount: 3
			},
			{
				fromDate: "2022-06-25",
				toDate: "2022-06-18",
				resolvedCount: 3,
				rejectedCount: 3
			},
			{
				fromDate: "2022-06-18",
				toDate: "2022-06-11"
			},
			{
				fromDate: "2022-06-11",
				toDate: "2022-06-04"
			},
			{
				fromDate: "2022-06-04",
				toDate: "2022-05-28",
				resolvedCount: 1,
				pendingCount: 1,
				rejectedCount: 1
			},
			{
				fromDate: "2022-05-28",
				toDate: "2022-05-21",
				pendingCount: 2
			}
		],
		complainWeeklyCount: [
			{
				fromDate: "2022-07-09"
			},
			{
				fromDate: "2022-07-08",
				pendingCount: 1
			},
			{
				fromDate: "2022-07-07"
			},
			{
				fromDate: "2022-07-06",
				pendingCount: 1
			},
			{
				fromDate: "2022-07-05"
			},
			{
				fromDate: "2022-07-04"
			},
			{
				fromDate: "2022-07-03"
			}
		],
		complainYearlyCount: [
			{
				pendingCount: 4,
				month: "JULY",
				year: 2022
			},
			{
				resolvedCount: 15,
				pendingCount: 2,
				rejectedCount: 3,
				month: "JUNE",
				year: 2022
			},
			{
				resolvedCount: 4,
				pendingCount: 13,
				rejectedCount: 4,
				month: "MAY",
				year: 2022
			},
			{
				resolvedCount: 5,
				pendingCount: 23,
				rejectedCount: 3,
				month: "APRIL",
				year: 2022
			},
			{
				resolvedCount: 2,
				pendingCount: 1,
				rejectedCount: 2,
				month: "MARCH",
				year: 2022
			},
			{
				pendingCount: 1,
				month: "FEBRUARY",
				year: 2022
			},
			{
				resolvedCount: 2,
				pendingCount: 10,
				rejectedCount: 6,
				month: "JANUARY",
				year: 2022
			},
			{
				resolvedCount: 1,
				pendingCount: 2,
				rejectedCount: 1,
				month: "DECEMBER",
				year: 2021
			},
			{
				month: "NOVEMBER",
				year: 2021
			},
			{
				month: "OCTOBER",
				year: 2021
			},
			{
				month: "SEPTEMBER",
				year: 2021
			},
			{
				month: "AUGUST",
				year: 2021
			}
		]
	};

	// console.log(tempArr.complainYearlyCount, "//////////////////////////");
	const [customerId, setCustomerId] = useState("");
	const [openDoc, setopenDoc] = useState(false);
	const [counterValue, setCounterValue] = useState([]);

	const [chartBtn, setChartBtn] = useState("barchart");
	const [dataCounterBtn, setDataCounterBtn] = useState("weekly");

	const [counterValueComplain, setCounterValueComplain] = useState([]);
	const [chartBtnComplain, setChartBtnComplain] = useState("");
	const [dataCounterBtnComplain, setDataCounterBtnComplain] =
		useState("weekly");

	// Complain Chart
	const barChartBtnComplain = () => {
		setChartBtnComplain("barchart");
	};

	const lineChartBtnComplain = () => {
		setChartBtnComplain("linechart");
	};

	const TableChartBtnComplain = () => {
		setChartBtnComplain("tablechart");
	};

	const weeklyChartDataBtnComplain = () => {
		setDataCounterBtnComplain("weekly");
		setCounterValueComplain(getWalletDashboardRes.data.weeklyTransaction);
		setChartBtnComplain("barchart");
		// setCounterValue(obj.weeklyCount)
	};

	const monthlyChartDataBtnComplain = () => {
		setDataCounterBtnComplain("monthly");
		setCounterValueComplain(getWalletDashboardRes.data.monthlyTransactionList);
		setChartBtnComplain("barchart");
		//  setCounterValue(obj.monthlyCount)
	};

	const yearlyChartDataBtnComplain = () => {
		setDataCounterBtnComplain("yearly");
		setCounterValueComplain(tempArr.complainYearlyCount);
		//setCounterValue(obj.yearlyCount)
	};

	const dispatch = useDispatch();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);
	var authToken = regenerateTokenRes.data.AuthToken;

	const [getWalletDashboardStatus, setGetWalletDashboardStatus] =
		useState(false);
	const [getWalletDashboardResArray, setgetWalletDashboardResArray] = useState(
		[]
	);



	var date = new Date();
	const [selectedDate, setSelectedDate] = useState(
		new Date(date.getFullYear(), date.getMonth(), 1)
	);
	const [selectedToDate, setSelectedToDate] = useState(new Date());
	// const [selectedDate, setSelectedDate] = useState(new Date());
	const [currency, setCurrency] = useState("");
	const [currencyLatest, setCurrencyLatest] = useState("");
	const hasInitialized = useRef(false);
	const hasInitializedCustomerList = useRef(false);   // ← ADD THIS LINE

	const handleChange = ({ target: { name, value } }) => {
		if (name === "currency") {
			setCurrency(value);
		}
	};

	const handleDateChange = (date) => {
		setSelectedDate(date);
		if (date > selectedToDate) {
			setSelectedToDate(date)
		}
	};

	const handleToDateChange = (date) => {
		setSelectedToDate(date);
		if (date < selectedDate) {
			setSelectedToDate(selectedDate)
		}
	};


	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	const getWalletDashboardRes = useSelector(
		({ getWalletDashboard }) => getWalletDashboard
	);
	const login = useSelector((state) => state.login);
	console.log("login", login)

	const getPartnerLogin = useSelector(({ login }) => login);
	console.log("getPartnerLoginrole", getPartnerLogin)

	const getTransactionCurrencyListRes = useSelector(
		({ getTransactionCurrencyList }) => getTransactionCurrencyList
	)

	const getCustomerIdAndNameListRes = useSelector(
		({ getCustomerIdAndNameList }) => getCustomerIdAndNameList
	);



	const currencyArray = [].concat(
		getTransactionCurrencyListRes?.data?.currencyList || []
	)
		.filter(Boolean)
		.map((currency) =>
			typeof currency === "string" ? currency.trim() : currency
		);

	const getTransactionCurrencyListFunc = () => {
		const requestData = {
			loginDetails: {
				walletOwnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId,
			},
		};
		dispatch(getTransactionCurrencyListAction(requestData, authToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status !== "success") return;
		if (hasInitialized.current) return;

		hasInitialized.current = true;
		getTransactionCurrencyListFunc();
	}, [regenerateTokenRes.data.status]);

	useEffect(() => {
		if (
			getTransactionCurrencyListRes?.success &&
			getTransactionCurrencyListRes?.data?.status === "success"
		) {
			if (currencyArray.length >= 1) {
				const selectedCurrency = currencyArray[0];
				setCurrency(selectedCurrency);
				setCurrencyLatest(selectedCurrency);
				getWalletDashBoard(selectedCurrency);
			} else {
				getWalletDashBoardFunc();
			}
		}
	}, [getTransactionCurrencyListRes]);


	const getWalletDashboardFunc = () => {
		if (getWalletDashboardStatus) {
			if (getWalletDashboardRes.data.status == "success") {
				setIsLoading(false);
				setgetWalletDashboardResArray(getWalletDashboardRes.data);
				const dashboardCurrency =
					typeof getWalletDashboardRes.data.currency === "string"
						? getWalletDashboardRes.data.currency.trim()
						: getWalletDashboardRes.data.currency;
				if (dashboardCurrency) {
					setCurrencyLatest(dashboardCurrency);
					setCurrency(dashboardCurrency);
				}
			}
			if (getWalletDashboardRes.data.status == "failed") {
				setIsLoading(false);
				setgetWalletDashboardResArray(getWalletDashboardRes.data);
				if (
					getWalletDashboardRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getWalletDashboardRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);

				}
			}

			if (getWalletDashboardRes.data.status == "Failed") {
				setIsLoading(false);
				setgetWalletDashboardResArray(getWalletDashboardRes.data);
				if (
					getWalletDashboardRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getWalletDashboardRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	const incomingFundData = {
		datasets: [
			{
				data: [
					getWalletDashboardRes.success &&
					getWalletDashboardResArray.dashboardList &&
					getWalletDashboardResArray.dashboardList
						.filter((r) => r.transactionType === "LOAD")
						.map((r) => r.transactionAmount),
					getWalletDashboardRes.success &&
					getWalletDashboardResArray.dashboardList &&
					getWalletDashboardResArray.dashboardList
						.filter((r) => r.transactionType === "REDEEM")
						.map((r) => r.transactionAmount),
					getWalletDashboardRes.success &&
					getWalletDashboardResArray.dashboardList &&
					getWalletDashboardResArray.dashboardList
						.filter((r) => r.transactionType === "RECEIVED")
						.map((r) => r.transactionAmount)
				],
				backgroundColor: ["#006400", "#456a84", "#36A2EB"],
				hoverBackgroundColor: ["#006400", "#456a84", "#36A2EB"]
			}
		],
		labels: ["LOAD", "REDEEM", "RECEIVED"]
	};

	const statusData = {
		datasets: [
			{
				data: [
					getWalletDashboardRes.success &&
					getWalletDashboardResArray.dashboardList &&
					getWalletDashboardResArray.dashboardList
						.filter((r) => r.transactionType === "LOAD")
						.map((r) => r.transactionCount),
					getWalletDashboardRes.success &&
					getWalletDashboardResArray.dashboardList &&
					getWalletDashboardResArray.dashboardList
						.filter((r) => r.transactionType === "SEND")
						.map((r) => r.transactionCount),
					getWalletDashboardRes.success &&
					getWalletDashboardResArray.dashboardList &&
					getWalletDashboardResArray.dashboardList
						.filter((r) => r.transactionType === "PURCHASE")
						.map((r) => r.transactionCount),
					getWalletDashboardRes.success &&
					getWalletDashboardResArray.dashboardList &&
					getWalletDashboardResArray.dashboardList
						.filter((r) => r.transactionType === "WITHDRAW")
						.map((r) => r.transactionCount),
					getWalletDashboardRes.success &&
					getWalletDashboardResArray.dashboardList &&
					getWalletDashboardResArray.dashboardList
						.filter((r) => r.transactionType === "RECEIVED")
						.map((r) => r.transactionCount),
					getWalletDashboardRes.success &&
					getWalletDashboardResArray.dashboardList &&
					getWalletDashboardResArray.dashboardList
						.filter((r) => r.transactionType === "REDEEM")
						.map((r) => r.transactionCount)
				],
				backgroundColor: [
					"#006400",
					"#ff0000",
					"#ef8157",
					"#ffa500",
					"#456a84",
					"#36a2eb"
				],
				hoverBackgroundColor: [
					"#006400",
					"#ff0000",
					"#ef8157",
					"#ffa500",
					"#456a84",
					"#36a2eb"
				]
			}
		],
		labels: ["LOAD", "SEND", "TRANSACTION", "WITHDRAW", "RECEIVED", "REDEEM"]
	};

	const outgoingFundData = {
		datasets: [
			{
				data: [
					getWalletDashboardRes.success &&
					getWalletDashboardResArray.dashboardList &&
					getWalletDashboardResArray.dashboardList
						.filter((r) => r.transactionType === "SEND")
						.map((r) => r.transactionAmount),
					getWalletDashboardRes.success &&
					getWalletDashboardResArray.dashboardList &&
					getWalletDashboardResArray.dashboardList
						.filter((r) => r.transactionType === "PURCHASE")
						.map((r) => r.transactionAmount),
					getWalletDashboardRes.success &&
					getWalletDashboardResArray.dashboardList &&
					getWalletDashboardResArray.dashboardList
						.filter((r) => r.transactionType === "WITHDRAW")
						.map((r) => r.transactionAmount)
				],
				backgroundColor: ["#ff0000", "#ef8157", "#ffa500"],
				hoverBackgroundColor: ["#ff0000", "#ef8157", "#ffa500"]
			}
		],
		labels: ["SEND", "TRANSACTION", "WITHDRAW"]
	};

	const getWalletDashBoard = (selectedCurrency = currency) => {
		setGetWalletDashboardStatus(true);
		setIsLoading(true);
		const req = {
			loginDetails: {
				walletOwnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId,
				loginRole: "Owner"
			},
			actionCustomerMasterRequestVO: {
				currency: selectedCurrency,
				customerId: customerId,
				fromDate: moment(selectedDate).format("DD/MM/YYYY"),
				toDate: moment(selectedToDate).format("DD/MM/YYYY")
			}
		};
		//console.log('getWalletDashboardResArray: ', getWalletDashboardResArray);
		return dispatch(getWalletDashboard(req, authToken));
	};

	function capitalizeFunc(input) {
		var words = input.replace("_", " ").toLowerCase().split(" ");
		var CapitalizedWords = [];
		words.forEach((element) => {
			CapitalizedWords.push(
				element[0].toUpperCase() + element.slice(1, element.length)
			);
		});
		return CapitalizedWords.join(" ");
	}

	const getWalletDashBoardFunc = () => {
		setIsLoading(true);
		setGetWalletDashboardStatus(true);
		const req = {
			loginDetails: {
				walletOwnerId: login.data.subRole === "" ? login.data.partnerId : login.data.parentId,
				loginRole: "Owner"
			},
			actionCustomerMasterRequestVO: {
				currency: "",
				fromDate: "",
				toDate: ""
			}
		};
		return dispatch(getWalletDashboard(req, regenerateTokenRes.data.AuthToken));
	};

	useEffect(() => {
		if (getWalletDashboardRes.data.status == "success") {
			weeklyChartDataBtnComplain();
		}
	}, [getWalletDashboardRes.data.status]);

	useEffect(() => {
		getWalletDashboardFunc();
	}, [getWalletDashboardRes.data.status]);


	const filterOptionsL = (options, { inputValue }) => {
		//console.log(options, inputValue, "optionsss")
		if (inputValue.length < 3) {
			return [];
		}

		const filterOptionsList = options.filter(
			(option) =>
				option.includes(inputValue) ||
				""
		);

		return filterOptionsList.slice(0, 20);
	}


	useEffect(() => {
		if (regenerateTokenRes.data.status !== "success") return;
		if (hasInitializedCustomerList.current) return;

		hasInitializedCustomerList.current = true;

		const getCustomerIdAndNameReq = {
			loginDetails: {
				walletOwnerId: login.data.subRole === ""
					? login.data.partnerId
					: login.data.parentId,
			},
			actionCustomerMasterRequestVO: { customerNameOrId: "" }
		};
		dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));
	}, [regenerateTokenRes.data.status]);

	return (
		<>
			<Layout>
				{isLoading ? (
					<div
						style={{
							flex: "1",
							alignItems: "center",
							justifyContent: "center",
							textAlign: "center"
						}}
					>
						<LoadingSpinner />
					</div>
				) : (
					<>
						<Grid container>
							{/* <Col
                xs={12}
                sm={6}
                md={4}
                lg={3}
              // key={id}
              // onClick={() => handleService(s.service, s.name)}
              >
                <Card>
                  <CardBody style={{ paddingBottom: "0" }}>
                    <Row>
                      <Col xs={5} md={4}>
                        <img
                          // src={`${process.env.PUBLIC_URL}/${themeDetails.theme}/${s.transactionType}.png`}
                          // alt={s.icon}
                          style={{ width: "75px" }}
                        />
                      </Col>
                      <Col xs={7} md={8} style={{ paddingLeft: "0" }}>
                        <div className="numbers" style={{ textAlign: "end" }}>
                          <p
                            className="card-category"
                            style={{ fontSize: "11px", margin: "0" }}
                          >
                            LOAD
                          </p>
                          <span style={{ display: "flex", float: "right" }}>
                            <p style={{ fontSize: "20px", paddingTop: "6px" }}>
                              {getSymbolFromCurrency(currencyLatest)}
                            </p>
                            <CountUp
                              style={{
                                fontSize: "20px",
                                display: "block",
                                paddingLeft: "10px",
                                paddingTop: "5px",
                              }}
                              start={0}
                              // end={Number(
                              //   s.transactionAmount
                              //     ? s.transactionAmount
                              //     : s.totalRedeemPoints
                              //       ? s.totalRedeemPoints
                              //       : s.totalFeePaidAmount
                              //         ? s.totalFeePaidAmount
                              //         : s.totalFeeReceivedAmount
                              //           ? s.totalFeeReceivedAmount
                              //           : "0.00"
                              // )}
                              delay={0}
                              decimals={2}
                              duration={2}
                            />
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                  <CardFooter style={{ padding: "6px" }}>
                    <hr style={{ margin: "0" }} />
                    <div style={{ padding: "5px 0px" }}>
                      <i className="fas fa-info-circle cust-card-footer-icon" />
                      <span
                        className="cust-card-footer-title"
                        style={{ fontSize: "10px" }}
                      >
                        Total Load
                      </span>
                    </div>
                  </CardFooter>
                </Card>
              </Col> */}
							{Array.isArray(getWalletDashboardResArray.dashboardList) &&
								getWalletDashboardResArray.dashboardList
									.filter(
										(s) =>
											!["LOAD", "SEND", "REDEEM"].includes(s.transactionType)
									)
									.sort((a, b) => {
										const order = ["PURCHASE", "RECEIVED", "FEE", "FEE RECEIVED", "WITHDRAW"];
										const normalize = (type) => type.replace(/_/g, " ").trim().toUpperCase();
										return order.indexOf(normalize(a.transactionType)) - order.indexOf(normalize(b.transactionType));
									})
									.map((s, index) => (
										<Col
											key={`${s.transactionType}-${index}`}
											xs={12}
											sm={6}
											md={4}
											lg={3}
										>
											<Card>
												<CardBody style={{ paddingBottom: "0" }}>
													<Row>
														<Col xs={5} md={4}>
															<img
																src={`${process.env.PUBLIC_URL}/${Theme}/${s.transactionType}.png`}
																alt={s.icon}
																style={{ width: "75px" }}
															/>
														</Col>
														<Col xs={7} md={8} style={{ paddingLeft: "0" }}>
															<div
																className="numbers"
																style={{ textAlign: "end" }}
															>
																<p
																	className="card-category"
																	style={{ fontSize: "11px", margin: "0" }}
																>
																	{s.transactionType === "PURCHASE"
																		? "TRANSACTION"
																		: s.transactionType.replace("_", " ")}
																</p>
																<span style={{ display: "flex", float: "right" }}>
																	<p
																		style={{
																			fontSize: "20px",
																			paddingTop: "6px"
																		}}
																	>
																		{getSymbolFromCurrency(currencyLatest)}
																	</p>
																	<CountUp
																		style={{
																			fontSize: "20px",
																			display: "block",
																			paddingLeft: "10px",
																			paddingTop: "5px"
																		}}
																		start={0}
																		end={Number(
																			s.transactionAmount
																				? s.transactionAmount
																				: s.totalRedeemPoints
																					? s.totalRedeemPoints
																					: s.totalFeePaidAmount
																						? s.totalFeePaidAmount
																						: s.totalFeeReceivedAmount
																							? s.totalFeeReceivedAmount
																							: "0.00"
																		)}
																		delay={0}
																		decimals={2}
																		duration={2}
																	/>
																</span>
															</div>
														</Col>
													</Row>
												</CardBody>
												<CardFooter style={{ padding: "6px" }}>
													<hr style={{ margin: "0" }} />
													<div style={{ padding: "5px 0px" }}>
														<i className="fas fa-info-circle cust-card-footer-icon" />
														<span
															className="cust-card-footer-title"
															style={{ fontSize: "10px" }}
														>
															{"Total " +
																capitalizeFunc(s.transactionType) +
																" Money"}
														</span>
													</div>
												</CardFooter>
											</Card>
										</Col>
									))}
						</Grid>
						<Card>
							<Grid
								container
								spacing={2}
								style={{ padding: "25px", marginTop: "2rem" }}
							>
								<Grid item xs={12} sm={12} md={4} lg={3}>
									<FormControl fullWidth>
										<LocalizationProvider dateAdapter={AdapterDateFns}>
											<DatePicker
												label="From Date"
												format="MM/dd/yyyy"
												name="fromDate"
												value={selectedDate}
												onChange={handleDateChange}
												disableFuture={true}
											/>
										</LocalizationProvider>
									</FormControl>
								</Grid>
								<Grid item xs={12} sm={12} md={4} lg={3}>
									<FormControl fullWidth>
										<LocalizationProvider dateAdapter={AdapterDateFns}>
											<DatePicker
												label="To Date"
												format="MM/dd/yyyy"
												name="toDate"
												value={selectedToDate}
												minDate={selectedDate}
												disableFuture={true}
												onChange={handleToDateChange}
											/>
										</LocalizationProvider>
									</FormControl>
								</Grid>
								<Grid item sm={12} md={4} lg={3} xs={12}>
									<TextField
										style={{ marginTop: "3px" }}
										select
										margin="dense"
										id="name"
										label="Currency"
										type="name"
										fullWidth
										name="currency"
										value={currency || ""}
										onChange={handleChange}
									>
										{/* ✅ Replace adminCurrencyList with getTransactionCurrencyListRes */}
										{getTransactionCurrencyListRes?.success &&
											getTransactionCurrencyListRes?.data?.status === "success" &&
											currencyArray
												.map((x) => (
													<MenuItem value={x} key={x}>{x}</MenuItem>
												))
										}
									</TextField>
								</Grid>
								<Grid item xs={12} sm={12} md={3} lg={3}>
									<Autocomplete
										id="combo-box-demo"
										options={[].concat(
											getCustomerIdAndNameListRes.data.currencyList || [""]
										)}
										getOptionLabel={(option) => option}
										filterOptions={filterOptionsL}
										value={customerId}
										onChange={handleChange}
										onInputChange={(event, newInputValue) => {
											setCustomerId(newInputValue);
										}}
										renderInput={(params) => (
											<TextField
												autoFocus
												margin="dense"
												id="name"
												label="Merchant ID"
												style={{ marginTop: "3px" }}
												// required
												type="tel"
												fullWidth
												{...params}
												sx={{
													"& .MuiInput-underline:before": {
														borderBottomColor: "gray", // White color for the underline before focus
													},
													"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
														borderBottomColor: "gray", // White color on hover
													},
													"& .MuiInput-underline:after": {
														borderBottomColor: "gray", // White color after focus
													},
												}}
												name="customerId"

												variant="standard"
											/>
										)}
									/>
								</Grid>
								<Grid
									item
									xs={12}
									sm={12}
									md={3}
									lg={3}

								>
									{/* <Button
                    style={{
                      // marginLeft: "0.7rem",
                      backgroundColor: "#00b9f5",
                      color: "white",
                      marginTop: "9px",
                    }}
                    endIcon={<AiOutlineSearch />}
                    variant="contained"
                    onClick={getWalletDashBoard}
                  >
                    Search
                  </Button> */}
									<CustomButton
										style={{
											padding: "8px",
											marginTop: "9px"
										}}
										onClick={() => getWalletDashBoard()}
									>
										Search <SearchIcon />
									</CustomButton>
								</Grid>
							</Grid>
						</Card>
						<Card style={{ zIndex: "0" }}>
							<Col md="12" sm="12">
								<Row>
									<Col md="9" sm="9">
										{/* <div
                  className="btn-group chart-btn-grup"
                  role="group"
                  aria-label="Basic example"
                >
                  <button
                    type="button"
                    // className={`btn btn-outline-info ${
                    className={`btn btn-outline-primary ${chartBtnComplain === "barchart" ? `active` : ``
                      }`}
                    onClick={barChartBtnComplain}
                  >
                    {chartBtnComplain === "barchart" ? (
                      <img
                        src={BarGraph_White}
                        alt="Bar"
                        style={{ width: "16px" }}
                      />
                    ) : (
                      <img src={BarGraph} alt="Bar" style={{ width: "16px" }} />
                    )}
                  </button>
                  <button
                    type="button"
                    // className={`btn btn-outline-info ${
                    className={`btn btn-outline-primary ${chartBtnComplain === "linechart" ? `active` : ``
                      }`}
                    onClick={lineChartBtnComplain}
                  >
                    {chartBtnComplain === "linechart" ? (
                      <img
                        src={LineGraph_White}
                        alt="Line"
                        style={{ width: "16px" }}
                      />
                    ) : (
                      <img
                        src={LineGraph}
                        alt="line"
                        style={{ width: "16px" }}
                      />
                    )}
                  </button>
                  <button
                    type="button"
                    className={`btn btn-outline-info ${chartBtnComplain === "tablechart" ? `active` : ``
                      }`}
                    onClick={TableChartBtnComplain}
                  >
                    {chartBtnComplain === "tablechart" ? (
                      <img
                        src={TableGraph_White}
                        alt="Table"
                        style={{ width: "16px" }}
                      />
                    ) : (
                      <img
                        src={TableGraph}
                        alt="Table"
                        style={{ width: "16px" }}
                      />
                    )}
                  </button>
                </div> */}
									</Col>
									<Col md="3" sm="3">
										<div
											className="btn-group graph__btn"
											role="group"
											aria-label="Basic example"
										>
											<button
												type="button"
												style={{
													backgroundColor: "#fff",
													fontWeight: "bold",
													color: "#808080",
													padding: "8px 16px",
													borderRadius: "4px",
													margin: "0 1px"
												}}
												className={` ${dataCounterBtnComplain === "weekly"
													? `switchactive`
													: `disabledbtn`
													}`}
												onClick={weeklyChartDataBtnComplain}
											>
												Week
											</button>
											<button
												type="button"
												style={{
													backgroundColor: "#fff",
													fontWeight: "bold",
													color: "#808080",
													padding: "8px 16px",
													borderRadius: "4px",
													margin: "0 1px"
												}}
												className={` ${dataCounterBtnComplain === "monthly"
													? `switchactive`
													: `disabledbtn`
													}`}
												onClick={monthlyChartDataBtnComplain}
											>
												Month
											</button>
											{/* <button
                    type="button"
                    className={`btn btn-outline-info ${dataCounterBtnComplain === "yearly" ? `active` : ``
                      }`}
                    onClick={yearlyChartDataBtnComplain}
                  >
                    Year
                  </button> */}
										</div>
									</Col>
								</Row>

								{chartBtnComplain == "barchart" ? (
									<GetComplainBarDashboard
										counterValue={counterValueComplain}
										chartBtnComplain={chartBtnComplain}
										dataCounterBtn={dataCounterBtnComplain}
									/>
								) : chartBtnComplain == "linechart" ? (
									<GetComplainLineChartDashboard
										counterValue={counterValueComplain}
										chartBtnComplain={chartBtnComplain}
										dataCounterBtn={dataCounterBtnComplain}
									/>
								) : (
									<GetComplainTableChartDashboard
										counterValue={counterValueComplain}
										chartBtnComplain={chartBtnComplain}
										dataCounterBtn={dataCounterBtnComplain}
									/>
								)}
							</Col>
						</Card>

						<Row>
							<Col sm={12} md={12}>
								<Card>
									<CardTitle>
										<h3
											className="themeText"
											style={{
												padding: "10px 10px 0",
												textAlign: "center",
												margin: "0px"
											}}
										>
											Status Chart
										</h3>
										<hr />
									</CardTitle>
									<CardBody>
										{/* {getWalletDashboardResArray.dashboardList && !dashboard.totalAmount ? (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    className="text-center my-4"
                  />
                ) : ( */}
										<Doughnut
											data={statusData}
											height={120}
										// options={{ maintainAspectRatio: false }}
										/>
										{/* )} */}
									</CardBody>
								</Card>
							</Col>
							<Col sm={12} md={6}>
								<Card>
									<CardTitle>
										<h3
											className="themeText"
											style={{
												padding: "10px 10px 0",
												textAlign: "center",
												margin: "0px"
											}}
										>
											Incoming Fund Chart
										</h3>
										<hr />
									</CardTitle>
									<CardBody>
										{/* {getWalletDashboardResArray.dashboardList && !dashboard.transactionCount ? (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    className="text-center container my-4"
                  />
                ) : ( */}
										<Doughnut data={incomingFundData} width={100} height={80} />
										{/* )} */}
									</CardBody>
								</Card>
							</Col>

							<Col sm={12} md={6}>
								<Card>
									<CardTitle>
										<h3
											className="themeText"
											style={{
												padding: "10px 10px 0",
												textAlign: "center",
												margin: "0px"
											}}
										>
											Outgoing Fund Chart
										</h3>
										<hr />
									</CardTitle>
									<CardBody>
										{/* {dashboard.summaryReport && !dashboard.totalAmount ? (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    className="text-center my-4"
                  />
                ) : ( */}
										<Doughnut data={outgoingFundData} width={100} height={80} />
										{/* )} */}
									</CardBody>
								</Card>
							</Col>
						</Row>
					</>
				)}
			</Layout>
		</>
	);
};

export default WalletDashboard;